import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';
import { useDropEventListFiltersContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
export const DropsListToolbar = (props) => {
    const { tabs } = props;
    const { tab, onTabChange } = useDropEventListFiltersContext();
    return (<div className="w-full flex border-b-[1px] border-dark-1">
			<ul className="flex gap-4 self-end">
				{tabs === null || tabs === void 0 ? void 0 : tabs.map(({ title, value }) => {
            const isSelected = tab && tab === value;
            return (<li key={value} className="flex flex-initial flex-col">
							<button className={twMerge('text-sm p-2 text-placeholder', isSelected && 'text-white')} onClick={() => {
                    onTabChange(value);
                }} type="button">
								{title}
							</button>
							{isSelected && <motion.div className="h-1 bg-primary w-full" layoutId="dropsTabsUnderline"/>}
						</li>);
        })}
			</ul>
		</div>);
};
